import React from "react";

import { plans } from '../../contexts/FeatureGating';
import { PlanAmount } from "./PlanAmount";

export function FeatureAmount({
  feature,
  label,
  values,
}) {
  return (
    <div className="row">
      <div className="col-feature">
        {label}
      </div>
      <div className="col-plan">
        <PlanAmount plan={plans.FREEMIUM} feature={feature} value={values[plans.FREEMIUM]} />
      </div>
      <div className="col-plan">
        <PlanAmount plan={plans.CLUB} feature={feature} value={values[plans.CLUB]} />
      </div>
      <div className="col-plan">
        <PlanAmount plan={plans.BLACK} feature={feature} value={values[plans.BLACK]} />
      </div>
    </div>
  );
}
